import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import "./index.css";
import { Grid } from "@mui/material";
import { TrapType } from "../../../types";
import FormTextField from "../../TextFiled/FormTextField";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleSave: (data: TrapType) => void;
  formData: TrapType;
}

interface FormDataErrors {
  displayName: string;
  attractant: string;
  description: string;
  trapType: string;
}

const TrapTypeCreationForm: React.FC<Props> = ({
  open,
  handleClose,
  handleSave,
  formData,
}) => {
  const [data, setData] = React.useState<TrapType>(formData);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errors, setErrors] = React.useState<FormDataErrors>({
    displayName: "",
    attractant: "",
    description: "",
    trapType: "",
  });

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({
      ...data,
      [name]: value,
    });
    // in case of error check add it right here
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSave(data);
    handleClose();
  };

  return (
    <>
      {open && (
        <div className="modal-trap-type">
          <Box className="modal-content-trap-type">
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                width: "100%",
              }}
            >
              <Grid container rowSpacing={1}>
                <FormTextField
                  name="displayName"
                  value={data.displayName}
                  handleChange={handleChange}
                  error={errors.displayName}
                  label="Display Name:"
                  required={true}
                />
                <FormTextField
                  name="trapType"
                  value={data.trapType}
                  handleChange={handleChange}
                  error={errors.trapType}
                  label="Collection Method:"
                />
                <FormTextField
                  name="attractant"
                  value={data.attractant}
                  handleChange={handleChange}
                  error={errors.attractant}
                  label="Attractant:"
                />
                <FormTextField
                  name="description"
                  value={data.description}
                  handleChange={handleChange}
                  error={errors.description}
                  label="Description:"
                />
                <Grid
                  size={6}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button variant="contained" type="submit">
                    Save
                  </Button>{" "}
                </Grid>
                <Grid
                  size={6}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </div>
      )}
    </>
  );
};

export default TrapTypeCreationForm;
